import { cuisines } from "../data/siteData";

export const Marquee = () => (
  <div
    data-testid="cuisine-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-line py-8 md:py-12 select-none"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {cuisines.map((c) => (
            <span key={`${dup}-${c}`} className="flex items-center">
              <span className="font-display italic text-4xl md:text-6xl text-forest/15 px-6 md:px-10 whitespace-nowrap">
                {c}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-gold/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
